import type { ErrorCode, FieldError } from '../types'

export class AppError extends Error {
  constructor(
    message: string,
    public readonly code: ErrorCode,
    public readonly statusCode: number = 0,
    public readonly fieldErrors?: FieldError[],
    public readonly raw?: unknown,
  ) {
    super(message)
    this.name = 'AppError'
  }

  is(code: ErrorCode): boolean {
    return this.code === code
  }

  isOneOf(...codes: ErrorCode[]): boolean {
    return codes.includes(this.code)
  }

  getFieldError(field: string): string | undefined {
    return this.fieldErrors?.find((e) => e.field === field)?.message
  }

  get isAuthError(): boolean {
    return this.statusCode === 401 || this.code === 'UNAUTHORIZED' || this.code === 'TOKEN_EXPIRED'
  }

  get isNetworkError(): boolean {
    return this.code === 'NETWORK_ERROR' || this.code === 'TIMEOUT' || this.code === 'OFFLINE'
  }

  get isValidationError(): boolean {
    return this.code === 'VALIDATION_ERROR' && !!this.fieldErrors?.length
  }

  get isCancelled(): boolean {
    return this.code === 'REQUEST_CANCELLED'
  }

  get isRetryable(): boolean {
    return this.code === 'NETWORK_ERROR' || this.code === 'TIMEOUT' || this.code === 'SERVER_ERROR' || this.code === 'SERVICE_UNAVAILABLE'
  }

  get isRateLimited(): boolean {
    return this.code === 'RATE_LIMITED'
  }
}
